import type { PropsWithChildren, ReactNode } from 'react'
import { View } from 'react-native'

import { DonationButton } from '@/src/elements/button/donation/DonationButton'
import { Header } from '@/src/elements/header'
import { useAccessibilityContext } from '@/src/features/accessibility/context/AccessibilityContext'
import { DONATION_SOURCE } from '@/src/features/donation/api/types/donation'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useDimensions } from '@/src/general/hooks/useDimensions'
import { useMenu } from '@/src/general/hooks/useMenu'
import { useTranslate } from '@/src/lang/useTranslate'

const MobileNoSelectedConversationLayout = ({ children }: PropsWithChildren): ReactNode => {
  const { openMenu } = useMenu()
  const { t } = useTranslate()

  const { initializeRef } = useAccessibilityContext()

  return (
    <View className="h-full w-full bg-white">
      <Header
        leftButtons={[
          {
            startIcon: ICON.BURGER_MENU,
            onPress: openMenu,
            type: 'icon',
            testID: TEST_ID.NAVIGATION.BURGER_MENU(),
            'aria-label': t('app.how-to.open-menu'),
            ref: (ref: View) => {
              initializeRef(ref, 'menu')
            },
          },
        ]}
        rightButtons={[
          {
            type: 'button',
            component: () => <DonationButton donationSource={DONATION_SOURCE.HEADER} isIconOnly />,
          },
        ]}
        showTabs
      />
      {children}
    </View>
  )
}

export const NoSelectedConversationLayout = ({ children }: PropsWithChildren): ReactNode => {
  const { xs } = useDimensions()

  if (xs) return <MobileNoSelectedConversationLayout>{children}</MobileNoSelectedConversationLayout>

  return <>{children}</>
}
